import { render, staticRenderFns } from "./EnvioInventarioComponent.vue?vue&type=template&id=c8d48886&"
import script from "./EnvioInventarioComponent.vue?vue&type=script&lang=js&"
export * from "./EnvioInventarioComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports